import ImeiSerialNumber from './ImeiSerialNumber'
export default ImeiSerialNumber
